import React from "react";

import { Tabs, TabsList, TabsTrigger } from "~/components/ui/tabs";

export type DebtType = "sales_requests" | "manual_facturas";

interface DebtTabSelectorProps {
  activeTab: DebtType;
  onTabChange: (tab: DebtType) => void;
}

export const DebtTabSelector: React.FC<DebtTabSelectorProps> = ({
  activeTab,
  onTabChange,
}) => {
  return (
    <Tabs
      value={activeTab}
      onValueChange={(value) => onTabChange(value as DebtType)}
      className="w-full"
    >
      <TabsList className="grid w-full grid-cols-2">
        <TabsTrigger value="sales_requests">Notas de Venta</TabsTrigger>
        <TabsTrigger value="manual_facturas">Facturas Manuales</TabsTrigger>
      </TabsList>
    </Tabs>
  );
};
